import React from "react";
import { Typography } from "@mui/material";
import Paper from "@components/Paper/Paper";
import { useTranslation } from "react-i18next";
import type { MovementServiceSection } from "../types";

interface MovementRemarksSectionProps {
  section: MovementServiceSection;
}

const MovementRemarksSection: React.FC<MovementRemarksSectionProps> = ({ section }) => {
  const { t } = useTranslation();

  return (
    <section
      className="flex flex-col gap-4 w-1/2"
      aria-labelledby="movement-service-remarks-title"
      data-testid="movement-service-section-remarks"
    >
      <Paper variant="outlined">
        <div className="flex flex-col gap-2">
          <Typography
            id="movement-service-remarks-title"
            component="h3"
            variant="subtitle1"
            sx={{ fontWeight: 600, color: "#111827" }}
          >
            {t(section.titleKey)}
          </Typography>
          {section.fields.map((field) => (
            <p
              key={field.labelKey}
              className="text-sm font-normal whitespace-pre-wrap wrap-break-word text-[#646A77]"
              data-testid="movement-service-section-remarks-comments-value"
            >
              {field.value}
            </p>
          ))}
        </div>
      </Paper>
    </section>
  );
};

export default MovementRemarksSection;
